import type { AppMe } from "@lumika/shared";

const SETUP_ROLES = new Set([
  "dealership_owner",
  "dealership_admin",
  "sales_manager",
  "service_manager",
]);

const USER_MANAGEMENT_ROLES = new Set(["dealership_owner", "dealership_admin"]);

// Both helpers take the whole `me` payload (not just memberships): system
// users hold no memberships at all — their flag IS the grant, mirroring the
// backend's `toPolicy` bypass.

export function canManageSetup(me: AppMe | undefined): boolean {
  if (!me) return false;
  // `?.` mirrors the permissions defense below: tolerate a partial payload
  // instead of crashing the shell render.
  if (me.user?.isSystemUser) return true;
  return me.memberships.some((membership) => {
    if (SETUP_ROLES.has(membership.role)) return true;
    // The shared contract allows permissions to be null — mirror the
    // backend's `?? {}` defense instead of crashing the shell render.
    const perms = (membership.permissions ?? {}) as Record<string, unknown>;
    return Boolean(perms.manageSetup || perms.manageChannels || perms.manageInventory);
  });
}

export function canManageUsers(me: AppMe | undefined): boolean {
  if (!me) return false;
  if (me.user?.isSystemUser) return true;
  return me.memberships.some((membership) => {
    if (USER_MANAGEMENT_ROLES.has(membership.role)) return true;
    const perms = (membership.permissions ?? {}) as Record<string, unknown>;
    return Boolean(perms.manageUsers);
  });
}
